import React, { useEffect, useState } from "react";
import {
  AcceptButton,
  ButtonsSection,
  Card,
  SectionTitle,
  TitleSection,
  Wrapper,
} from "../Properties/Details/styles";
import requestAPI from "../../utils/requestAPI";
import settings from "../../apiConfigs/settings";
import { RenderIcons } from "../../designComponents/Table/renderMethods";
import { toast } from "react-toastify";
import { uploadFilesToS3OnlyKeys } from "../../utils/s3Upload";
import Modal from "../../designComponents/Modal";
import MediaUploader from "../../designComponents/MediaUpload/MediaUpload";

function Inventory() {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [inventoryIcons, setInventoryIcons] = useState<
    {
      icon: string;
      _id: string;
    }[]
  >([]);
  const getInventoryIcons = async () => {
    try {
      const response = await requestAPI(settings.getInventoryIcons());
      setInventoryIcons(response.data);
    } catch (error) {}
  };
  const handleOnDelete = async (id: string) => {
    try {
      await requestAPI(settings.deleteInventoryIcons(id));
      toast.success("Successfully deleted");
      getInventoryIcons();
    } catch (error: any) {
      toast.error("Error" + error.message);
    }
  };
  const handleUpload = async () => {
    let providedUrl;

    try {
      console.log(uploadedFile, "file");
      if (uploadedFile && typeof uploadedFile !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({category:'assets',fileUri:[uploadedFile],assetsCategory:'Inventory'});
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
          await requestAPI(settings.addInventoryIcons({ icon: providedUrl }));
        }
      } else if (typeof uploadedFile === "string") {
        providedUrl = uploadedFile;
        await requestAPI(settings.addInventoryIcons({ icon: providedUrl }));
      }
      getInventoryIcons();
      setOpenModal(false);
      toast.success("Successfully Added Icon");
      providedUrl = "";
      setUploadedFile(null);
    } catch (error: any) {
      toast.error(error.message);
    }
  };
  const handleDeleteClick = async (id: string) => {
    try {
      await requestAPI(settings.deleteInventoryIcons(id));
      toast.success("Succefully Deleted");
      getInventoryIcons();
    } catch (error: any) {
      toast.error(error.message);
    }
  };
  useEffect(() => {
    getInventoryIcons();
  }, []);
  return (
    <div>
      <Modal
        isOpen={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        halfWidth={true}
        title="Pick a Icon"
      >
        <MediaUploader
          label="Amenity Icon"
          onChange={(e) => {
            const file = e.target.files?.[0] || null;
            setUploadedFile(file);
          }}
          style={{
            container: { paddingTop: 10, gap: 6 },
            label: { paddingBottom: 10, color: "#555A77" },
            dropzone: { background: "#F1EFFB" },
          }}
        ></MediaUploader>
        <ButtonsSection style={{ paddingTop: 10 }}>
          <AcceptButton
            onClick={() => {
              handleUpload();
            }}
          >
            Add Icon
          </AcceptButton>
        </ButtonsSection>
      </Modal>
      <Card style={{ margin: 0 }}>
        <TitleSection>
          <ButtonsSection>
            <SectionTitle>Inventory</SectionTitle>
            <AcceptButton
              onClick={() => {
                setOpenModal(true);
              }}
            >
              Add Icon
            </AcceptButton>
          </ButtonsSection>
        </TitleSection>
        <RenderIcons
          icons={inventoryIcons}
          onDelete={(id) => {
            handleOnDelete(id);
          }}
        ></RenderIcons>
      </Card>
    </div>
  );
}

export default Inventory;
